<div
  class="frame"
  [style.background-color]="backgroundColor"
>
  <app-flex
    gap="0"
    [direction]="direction"
    [justify]="justify"
    [align]="align"
    [wrap]="wrap"
    [padding]="padding"
    [margin]="margin"
    [textAlign]="textAlign"
    [height]="height"
    [width]="width"
  >
    <div
      class="title display-lg-bold"
      [style.font-size.px]="fontSize"
    >
      {{ title }}
    </div>
    @if (subTitle) {
      <div class="subtitle">
        {{ subTitle }}
      </div>
    }
    <app-flex
      [direction]="'row'"
      [justify]="'center'"
    >
      <ng-content />
    </app-flex>
  </app-flex>
</div>
